import React, { lazy, Suspense } from "react"
import PropTypes from "prop-types"
import { Loading } from "../../../../shared/shared.ui.loading"

const Niches = lazy(() =>
  import("../TopicNiches").then(module => ({ default: module.Niches }))
)

const ContextTab = lazy(() =>
  import("../TopicContext").then(module => ({ default: module.ContextTab }))
)

export const ContextOrNichesWrapper = ({ topicId, match, history, location }) => {
  const contextId = match.params.contextId
  const searchParams = new URLSearchParams(location?.search || '')
  const contextName = searchParams.get('contextName')
  const formattedTopicId = `topic.${topicId}`

  if (contextId) {
    return (
      <Suspense fallback={<Loading />}>
        <Niches
          topicId={formattedTopicId}
          contextId={contextId}
          contextName={contextName}
          history={history}
        />
      </Suspense>
    )
  }

  return (
    <Suspense fallback={<Loading />}>
      <ContextTab topicId={formattedTopicId} />
    </Suspense>
  )
}

ContextOrNichesWrapper.propTypes = {
  topicId: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}
